import { EventCard, Pagination, useText } from '@kkf/design'
import { EVENTS } from '../data/events'
import { useT } from '../i18n'

/** The events page. */
export function EventsPage() {
  const t = useT()
  const s = useText()
  return (
    <>
      {/*
        No banner and no breadcrumb (2026-09-21), the way `/about`, `/contact`, `/blog` and
        the legal pair lost theirs. `Breadcrumb` IS the photographic band — the trail sat
        inside it — so both went together. Two things travel with that, and each passes
        every gate this repo has:

        1. **It carried the page's only `<h1>`.** `audit:seo` fails a page with any number
           other than one, so the title is `.ul-plain-page-title` here — the class that
           exists for exactly this, beside `.ul-plain-page-top` in `_header.scss`.
        2. **The page now opens pale**, and the header's links are white at rest because
           the usual first section is a dark band. This route is in `header.plainRoutes`
           in `data/shell` as of the same day. Forget that and every link in the nav is
           white on near-white, and nothing anywhere goes red.
      */}
      <section className="ul-plain-page-top ul-section-spacing">
        <div className="ul-container">
          <h1 className="ul-plain-page-title">{t('nav.events')}</h1>
          {/* events */}
          <div className="ul-events-wrapper">
            <div className="row ul-bs-row row-cols-lg-2 row-cols-1">
              {EVENTS.map((event, i) => (
                <div className="col wow animate__fadeInUp" key={`${event.image}-${i}`}>
                  {/* The card takes plain strings; the entry carries both languages. */}
                  <EventCard
                    {...event}
                    month={s(event.month)}
                    title={s(event.title)}
                    descr={s(event.descr)}
                    infoTitle={t(event.infoTitleKey)}
                    infoDescr={s(event.infoDescr)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <Pagination />
      </section>
    </>
  )
}
